import { Injectable } from "@angular/core";
import { STANDALONE } from "../../../_offline/electron.constants";

interface OnPremiseCreatedData {
  [id: string]: string;
}

type OnPremiseSyncData = {
  inspectionTemplate: OnPremiseCreatedData;
  subjects: OnPremiseCreatedData;
  inspections: OnPremiseCreatedData;
  inspectionImages: OnPremiseCreatedData;
  reports: OnPremiseCreatedData;
  reportTemplates: OnPremiseCreatedData;
}

@Injectable({
  providedIn: 'root'
})
export class OnPremiseSyncDataState {
  public syncDataState: OnPremiseSyncData = { inspectionTemplate: {}, subjects: {}, inspections: {}, inspectionImages: {}, reports: {}, reportTemplates: {} };

  public updateInspectionTemplate(schemaId: string, createdId: string) {
    this.syncDataState.inspectionTemplate[schemaId] = createdId;
  }

  public updateSubjects(schemaId: string, createdId: string) {
    this.syncDataState.subjects[schemaId] = createdId;
  }

  public updateInspection(createdId: string, schemaId: string) {
    this.syncDataState.inspections[schemaId] = createdId;
  }

  public updateInspectionImage(createdId: string, schemaId: string) {
    this.syncDataState.inspectionImages[schemaId] = createdId;
  }

  public updateReport(schemaId: string, createdId: string) {
    this.syncDataState.reports[schemaId] = createdId;
  }

  public updateReportTemplate(schemaId: string, createdId: string) {
    this.syncDataState.reportTemplates[schemaId] = createdId;
  }

  public getInspectionTemplateId(schemaId: string) {
    return this.syncDataState.inspectionTemplate[schemaId];
  }

  public getSubjectId(schemaId: string) {
    return this.syncDataState.subjects[schemaId];
  }

  public getInspectionId(schemaId: string) {
    return this.syncDataState.inspections[schemaId];
  }

  public getInspectionImageId(schemaId: string) {
    return this.syncDataState.inspectionImages[schemaId];
  }

  public getReportTemplateId(schemaId: string) {
    return this.syncDataState.reportTemplates[schemaId];
  }

  public getOnPremiseUserId() {
    return STANDALONE.USER_ID;
  }

  public getOnPremiseTenantId() {
    return STANDALONE.TENANT_ID;
  }

}
